import React, { useState } from "react";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer";
import { Link, useNavigate } from "react-router-dom";
import Axios from "../../axios/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [forgot, setForgot] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // 🔹 Handle Login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await Axios.post(`api/user/loginUser`, {
        phone,
        password,
      });

      if (response.status === 200) {
        const user = response.data;

        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            ...user,
            phone: phone,
          }),
        );
        const storedUser = JSON.parse(localStorage.getItem("userInfo"));
        toast.success("Successfully logged in");
        setTimeout(() => navigate("/"), 1000);
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 1: Send OTP
  const handlePassword = async () => {
    if (!phone) {
      toast.error("Please enter your phone number");
      return;
    }

    setLoading(true);
    try {
      const response = await Axios.post("api/user/forgotPassword", { phone });
      if (response.status === 200) {
        toast.success("OTP sent to your registered email");
        setTimeout(() => setOtpModal(true), 500);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Step 2: Verify OTP
  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    try {
      const response = await Axios.post("api/user/verifyOtp", { phone, otp });
      if (response.status === 200) {
        toast.success("OTP verified successfully");
        setOtpModal(false);
        setResetModal(true);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid or expired OTP");
    }
  };

  // 🔹 Step 3: Reset Password
  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill both password fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const response = await Axios.post("api/user/resetPassword", {
        phone,
        newPassword,
      });

      if (response.status === 200) {
        toast.success("Password reset successfully");
        setResetModal(false);
        setForgot(false);
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Reset failed");
    }
  };

  return (
    <body className="cart-page cart-style1-page">
      <div className="page-wrapper">
        <Header />
        <ToastContainer />

        <div
          id="page-content"
          className={otpModal || resetModal ? "blurred" : ""}
        >
          <div className="page-header text-center">
            <div className="container">
              <h1>LOGIN HERE</h1>
            </div>
          </div>

          <div className="container">
            <div className="login-register pt-2">
              <div className="row">
                {forgot ? (
                  // Forgot Password Form
                  <div className="col-12 col-md-6 offset-md-3">
                    <div className="inner">
                      <h3 className="text-center mb-3">Forgot Password</h3>
                      <input
                        type="number"
                        className="form-control mb-3"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Enter your phone number"
                        required
                      />
                      <button
                        className="btn btn-primary w-100"
                        disabled={loading}
                        onClick={handlePassword}
                      >
                        {loading ? "Sending..." : "Send OTP"}
                      </button>
                      <p
                        className="text-center mt-3"
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => setForgot(false)}
                      >
                        Back to Login
                      </p>
                    </div>
                  </div>
                ) : (
                  // Login Form
                  <div className="col-12 col-md-6 offset-md-3">
                    <div className="inner">
                      <form onSubmit={handleSubmit}>
                        <h3 className="text-center mb-3">Registered Users</h3>
                        <input
                          type="number"
                          className="form-control mb-3"
                          placeholder="Phone number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                        <div className="input-group mb-3">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <i className="fa fa-eye-slash"></i>
                            ) : (
                              <i className="fa fa-eye"></i>
                            )}
                          </button>
                        </div>

                        <div className="text-end mb-3">
                          <span
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={() => setForgot(true)}
                          >
                            Forgot Password?
                          </span>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={loading}
                        >
                          {loading ? "Logging in..." : "Login"}
                        </button>
                        <p className="text-center mt-3">
                          Don’t have an account?{" "}
                          <Link
                            to="/signup"
                            style={{ fontWeight: "bold", color: "blue" }}
                          >
                            Register
                          </Link>
                        </p>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 🔹 OTP Modal */}
        {otpModal && (
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-4">
                <h4 className="mb-3 text-center">Enter OTP</h4>
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button
                  className="btn btn-primary w-100"
                  onClick={handleVerifyOtp}
                >
                  Verify OTP
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 🔹 Reset Password Modal */}
        {resetModal && (
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-4">
                <h4 className="mb-3 text-center">Reset Password</h4>
                <div className="input-group mb-3">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? (
                      <i className="fa fa-eye-slash"></i>
                    ) : (
                      <i className="fa fa-eye"></i>
                    )}
                  </button>
                </div>
                {/* Confirm Password Input */}
                <div className="input-group mb-3">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <i className="fa fa-eye-slash"></i>
                    ) : (
                      <i className="fa fa-eye"></i>
                    )}
                  </button>
                </div>

                <button
                  className="btn btn-success w-100"
                  onClick={handleResetPassword}
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </body>
  );
}
